<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <form @submit.prevent="validateForm">
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4" v-if="itemsCompany">
              <label class="label text-secondary">Empresa/Institución</label>
              <select
                class="form-select form-control h-45"
                aria-label="Default select example"
                v-model="team.companyId"
                @change="clearError('companyId')"
              >
                <option :value="null">-- Seleccionar --</option>
                <option
                  :value="company.id"
                  v-for="(company, i) of itemsCompany"
                  :key="i"
                >
                  {{ company.name }}
                </option>
              </select>
              <div class="input-error">{{ errors.companyId }}</div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary mb-2">Torneos</label>
              <div
                class="vue3-select-custom-container"
                style="position: relative; width: 100%"
              >
                <Multiselect
                  v-model="team.tournamentIds"
                  mode="tags"
                  placeholder="-- Seleccionar --"
                  :options="
                    itemsTournament.map((t) => ({ value: t.id, label: t.name }))
                  "
                  @change="clearError('tournamentIds')"
                />
              </div>

              <div class="input-error mt-1">{{ errors.tournamentIds }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Nombre</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar el nombre del equipo"
                v-model.trim="team.name"
                @input="clearError('name')"
              />
              <div v-if="errors.name" class="input-error">
                {{ errors.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Descripción</label>
              <textarea
                rows="4"
                style="resize: none"
                class="form-control text-dark no-resize"
                placeholder="Ingresar la descripción del equipo"
                v-model.trim="team.description"
                @input="clearError('description')"
              ></textarea>
              <!--    <div v-if="errors.description" class="input-error">
                {{ errors.description }}
              </div> -->
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-8 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary"
                >Nombre del apoderado/gerente (opcional)</label
              >
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar el nombre del apoderado/gerente"
                v-model.trim="team.managerName"
                @input="clearError('managerName')"
              />
              <div v-if="errors.managerName" class="input-error">
                {{ errors.managerName }}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4" v-if="itemsDocumentType">
              <label class="label text-secondary"
                >Tipo documento (opcional)</label
              >
              <select
                class="form-select form-control h-45"
                aria-label="Default select example"
                v-model="team.documentTypeId"
                @change="clearError('documentTypeId')"
              >
                <option :value="null">-- Seleccionar --</option>
                <option
                  :value="documentType.id"
                  v-for="(documentType, i) of itemsDocumentType"
                  :key="i"
                >
                  {{ documentType.name }}
                </option>
              </select>
              <div class="input-error">{{ errors.documentTypeId }}</div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary"
                >Documento de identidad (opcional)</label
              >
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar el username"
                v-model.trim="team.documentNumber"
                @input="clearError('documentNumber')"
              />
              <div class="input-error">{{ errors.documentNumber }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary"
                >Correo contacto (gestor de cuenta) (opcional)</label
              >
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar el correo electrónico del contacto"
                v-model.trim="team.contactEmail"
                @input="clearError('contactEmail')"
              />
              <div class="input-error">{{ errors.contactEmail }}</div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary"
                >Teléfono/Celular (opcional)</label
              >
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar el Teléfono/Celular"
                v-model.trim="team.phoneNumber"
                @input="clearError('phoneNumber')"
              />
              <div class="input-error">{{ errors.phoneNumber }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="form-group mb-4">
              <label class="label text-secondary">Portada</label>
              <div v-if="team.urlPhoto">
                <img
                  :src="team.urlPhoto"
                  alt="Portada de Equipo"
                  class="img-fluid mb-2 d-block"
                />
                <button @click.prevent="removePhotoFile" class="btn btn-danger">
                  Eliminar portada
                </button>
              </div>
              <FilePond
                name="photo"
                :maxFileSize="'2MB'"
                :accepted-file-types="supportedFormats"
                allow-multiple="false"
                :max-files="1"
                label-idle="Arrastra tu imagen o <span class='filepond--label-action'>Buscar</span>"
                :labelMaxFileSizeExceeded="'El archivo es demasiado grande'"
                :labelMaxFileSize="'El tamaño máximo permitido es {filesize}'"
                :labelFileTypeNotAllowed="'El archivo tiene una extensión no permitida'"
                :fileValidateTypeLabelExpectedTypes="`Los tipos de archivo permitidos son: ${supportedFormats.join(
                  ', '
                )}`"
                credits=""
                @updatefiles="handleUpdateFiles"
                @input="clearError('photo')"
                v-if="!team.urlPhoto"
              />
              <div class="input-error">{{ errors.photo }}</div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="d-flex flex-wrap gap-3">
              <RouterLink to="/teams">
                <button
                  type="button"
                  class="btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                >
                  Cancelar
                </button>
              </RouterLink>
              <button
                class="btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4"
                type="submit"
                :disabled="isLoading"
              >
                <span v-if="!isLoading">{{
                  team.id == 0 ? "Crear Equipo" : "Actualizar Equipo"
                }}</span>
                <span
                  class="spinner-border spinner-border-sm me-2"
                  aria-hidden="true"
                  v-if="isLoading"
                ></span>
                <span role="status" v-if="isLoading">Procesando...</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { teamSchema } from "@/schemas/teamSchema";
import { defineComponent, ref, onMounted } from "vue";
import api from "@/services/api";
import { useToast } from "vue-toastification";
import { useRouter, useRoute } from "vue-router";
import { COMPANY_TYPES } from "@/utils/constants";
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "@vuepic/vue-datepicker/dist/main.css";

import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import { es } from "date-fns/locale";

import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
// Create FilePond component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginImagePreview
);

export default defineComponent({
  name: "createTeam",
  components: { FilePond, Multiselect },

  setup() {
    const toast = useToast();
    const route = useRoute();
    const router = useRouter();
    const isLoading = ref(false);
    const itemsCompany = ref<any[]>([]);
    const itemsTournament = ref<any[]>([]);
    const itemsDocumentType = ref<any[]>([]);
    const team = ref({
      id: 0,
      name: "",
      description: null,
      tournamentIds: [],
      companyId: null,
      photo: null,
      urlPhoto: null,
      documentTypeId: null,
      documentNumber: null,
      phoneNumber: null,
      managerName: null,
      contactEmail: null,
    });
    const errors = ref<Record<string, string>>({});

    const supportedFormats = ["image/jpg", "image/jpeg", "image/png"];

    onMounted(async () => {
      await getTournament();
      await getCompanies();
      await getDocumentType();
      var idTeam = route.params.id;
      if (idTeam) {
        await getTeamById(idTeam);
      }
    });
    const getTournament = async () => {
      try {
        var params = `pageNumber=1&pageSize=99999&isActive=true`;

        const response = await api.get(`/tournament?${params}`);

        itemsTournament.value = response.data.list;
      } catch (error) {
        console.error(error);
      }
    };
    const getCompanies = async () => {
      try {
        const response = await api.get(
          `/common/companies?type=${COMPANY_TYPES.PARTICIPANTE}`
        );
        itemsCompany.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };

    const getDocumentType = async () => {
      try {
        const response = await api.get(`/common/document-type`);
        itemsDocumentType.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };
    const handleUpdateFiles = (fileItems: any[]) => {
      team.value.photo = fileItems.length ? fileItems[0].file : null;
    };

    const validateForm = async () => {
      try {
        errors.value = {};
        await teamSchema.validate(team.value, {
          abortEarly: false,
          context: {
            id: team.value.id,
            tournamentIds: team.value.tournamentIds,
          },
        });
        isLoading.value = true;

        await createTeam();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " + err);
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false;
      }
    };

    const clearError = (field: string) => {
      errors.value[field] = "";
    };

    const buildFormData = (data: any) => {
      const formData = new FormData();
      for (const key in data) {
        if (
          data[key] !== undefined &&
          data[key] !== null &&
          key != "createdBy"
        ) {
          formData.append(key, data[key]);
        }
      }
      return formData;
    };

    const getTeamById = async (id: any) => {
      try {
        const response = await api.get(`/team/${id}`);
        const responseFormat = response.data;
        responseFormat.teamId = responseFormat.id;
        responseFormat.companyId = responseFormat.company.id;
        if (responseFormat.photo) {
          responseFormat.urlPhoto =
            process.env.VUE_APP_API_URL + "/" + responseFormat.photo;
        }
        team.value = responseFormat;
      } catch (ex) {
        console.error(ex);
      }
    };

    const createTeam = async () => {
      try {
        const payload = {
          ...team.value,
        };

        const formData = buildFormData(payload);

        formData.delete("tournamentIds");

        if (payload.tournamentIds && payload.tournamentIds.length > 0) {
          payload.tournamentIds.forEach((id: number) => {
            formData.append("tournamentIds", id.toString());
          });
        }
        const response: any = await api.postForm(`/team`, formData);

        if (response.data.return) {
          toast.success(
            `El equipo fue ${
              team.value.id == 0 ? "creado" : "actualizado"
            } con éxito.`,
            {
              timeout: 2000,
            }
          );

          router.push({ name: "TeamsPage" });
        }
      } catch (ex) {
        toast.error("El equipo no pudo ser creado.", {
          timeout: 2000,
        });
        console.error(ex);
      }
    };

    const removePhotoFile = async () => {
      team.value.urlPhoto = null;
    };

    return {
      handleUpdateFiles,
      createTeam,
      validateForm,
      clearError,
      removePhotoFile,
      team,
      itemsTournament,
      itemsDocumentType,
      itemsCompany,
      errors,
      isLoading,
      es,
      supportedFormats,
    };
  },
});
</script>
<style >
:deep(.v-select) {
  --vs-dropdown-max-height: 250p !important;
}
</style>